// Enums

// Represents all possible values of types of Authentification providers
export const AuthProviderType = Object.freeze({
  UNDEFINED: 0,
  IDENTITY_SERVER: 1,
  ADFS: 2,
});

// Represents all possible values of types of Exercice sorting (exercices datatable)
export const ExerciceSortType = Object.freeze({
  UNDEFINED: 0,
  ID: 1,
  TITLE: 2,
  DESTINATION: 3,
  EMAIL: 4,
  TYPENAME: 5,
  DISCIPLINE: 6,
});

// Represents all possible values of types of Cycle sorting (cycles datatable)
export const CycleSortType = Object.freeze({
  UNDEFINED: 0,
  ID: 1,
  NAME: 2,
  DESTINATION: 3,
  EMAIL: 4,
  DIFFICULTY: 5,
  INTENSITY: 6,
});

// Represents all possible values of types of Exercice
export const ExerciseType = Object.freeze({
  UNDEFINED: 0,
  EXERCISE: 1,
  EVALUATION: 2,
  REFERENCE: 3,
});

// Represents all possible values of types of Exercice
export const DestinationType = Object.freeze({
  UNDEFINED: 0,

  /// <summary>
  /// All users can see the exercise. Not related to any federation nor discipline nor coach. (it replaces TRANSVERSAL = 1)
  /// </summary>
  PUBLIC: 1,

  /// <summary>
  /// All users in the related discipline can see the exercise. (it replaces SPECIFIC = 2)
  /// </summary>
  DISCIPLINE: 2,

  /// <summary>
  /// All users in the related federation can see the exercise.
  /// </summary>
  FEDERAL: 3,

  /// <summary>
  /// All users in a team of the related coach can see the exercise.
  /// </summary>
  COACH: 4,
});

// Represents all possible values of types of Media
export const MediaType = Object.freeze({
  // Empty value
  UNDEFINED: 0,

  // Image
  IMAGE: 1,

  // Video
  VIDEO: 2,

  // Others
  OTHER: 3,

  // Url
  URL: 4,
});
